import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SpeedInsights } from "@vercel/speed-insights/react";
import MainHeader from "./components/MainHeader";
import AdminLayout from "./components/AdminLayout";

// --- Public Pages ---
import MainPage from "./pages/MainPage";
import BrandStoryPage from './pages/BrandStoryPage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import SelfCheckInPage from './pages/SelfCheckInPage';
import EventQrCodePage from './pages/EventQrCodePage';
import TicketPurchasePage from './pages/TicketPurchasePage';
import MembershipPage from './pages/MembershipPage';
import PartnershipPage from './pages/PartnershipPage';
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import MyPage from "./pages/MyPage";
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import UserProfilePage from './pages/UserProfilePage';


// --- Admin Pages ---
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminActionPlanPage from './pages/AdminActionPlanPage';
import AdminTemplatesPage from './pages/AdminTemplatesPage';
import AdminResourcesPage from './pages/AdminResourcesPage';
import AdminFeedbackPage from './pages/AdminFeedbackPage';
import AdminStaffInfoPage from './pages/AdminStaffInfoPage';
import AdminMemberManagementPage from './pages/AdminMemberManagementPage';
import AdminAccountingPage from './pages/AdminAccountingPage';
import AdminAccountingDetailPage from './pages/AdminAccountingDetailPage';
import AdminEventsPage from './pages/AdminEventsPage';
import AdminGamesPage from './pages/AdminGamesPage';
import AdminPartnershipPage from './pages/AdminPartnershipPage';
import GameAnalyticsPage from './pages/GameAnalyticsPage';

//Feedbackform
import FeedbackFormPage from './pages/FeedbackFormPage';
import StaffFeedbackFormPage from './pages/StaffFeedbackFormPage';
import CommunityPage from './pages/CommunityPage';
import NewPostPage from './pages/NewPostPage';
import PostDetailPage from './pages/PostDetailPage';
import StaffOnboardingPage from './pages/StaffOnboardingPage';
import GoogleCallbackPage from './pages/GoogleCallbackPage';
import StaffApplicationFormPage from './pages/StaffApplicationFormPage';
import AdminStaffApplicationPage from './pages/AdminStaffApplicationPage';


// --- Public Layout Component ---
const PublicLayout = ({ children }) => (
  <>
    <MainHeader />
    {children}
  </>
);

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PublicLayout><MainPage /></PublicLayout>} />
        <Route path="/about-us" element={<PublicLayout><BrandStoryPage /></PublicLayout>} />
        <Route path="/events" element={<PublicLayout><EventsPage /></PublicLayout>} />
        <Route path="/events/:eventId" element={<PublicLayout><EventDetailPage /></PublicLayout>} />
        <Route path="/events/:eventId/check-in" element={<PublicLayout><SelfCheckInPage /></PublicLayout>} />
        <Route path="/events/:eventId/qr-code" element={<PublicLayout><EventQrCodePage /></PublicLayout>} />
        <Route path="/events/:eventId/ticket" element={<PublicLayout><TicketPurchasePage /></PublicLayout>} />
        <Route path="/membership" element={<PublicLayout><MembershipPage /></PublicLayout>} />
        <Route path="/partnership" element={<PublicLayout><PartnershipPage /></PublicLayout>} />
        <Route path="/community" element={<PublicLayout><CommunityPage /></PublicLayout>} />
        <Route path="/community/new" element={<PublicLayout><NewPostPage /></PublicLayout>} />
        <Route path="/community/post/:postId" element={<PublicLayout><PostDetailPage /></PublicLayout>} />
        <Route path="/login" element={<PublicLayout><LoginPage /></PublicLayout>} />
        <Route path="/signup" element={<PublicLayout><SignupPage /></PublicLayout>} />
        <Route path="/mypage" element={<PublicLayout><MyPage /></PublicLayout>} />
        <Route path="/change-password" element={<PublicLayout><ChangePasswordPage /></PublicLayout>} />
        <Route path="/users/:userId" element={<PublicLayout><UserProfilePage /></PublicLayout>} />
        <Route path="/users/profile" element={<PublicLayout><UserProfilePage /></PublicLayout>} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/forgot-password" element={<PublicLayout><ForgotPasswordPage /></PublicLayout>} />
        <Route path="/staff-onboarding" element={<StaffOnboardingPage />} />
        <Route path="/staff-application" element={<PublicLayout><StaffApplicationFormPage /></PublicLayout>} />
        <Route path="/auth/google/callback" element={<GoogleCallbackPage />} />

        {/* Standalone Feedback Form Page */}
        <Route path="/feedback/event/:eventId" element={<FeedbackFormPage />} />
        <Route path="/feedback/staff/:eventId" element={<StaffFeedbackFormPage />} />
        
        {/* Admin Routes (Nested inside AdminLayout) */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<AdminDashboardPage />} />
          <Route path="templates" element={<AdminTemplatesPage />} />
          <Route path="tasks" element={<AdminActionPlanPage />} />
          <Route path="resources" element={<AdminResourcesPage />} />
          <Route path="feedback" element={<AdminFeedbackPage />} />
          <Route path="staff" element={<AdminStaffInfoPage />} />
          <Route path="members" element={<AdminMemberManagementPage />} />
          <Route path="accounting" element={<AdminAccountingPage />} />
          <Route path="accounting/:semesterId" element={<AdminAccountingDetailPage />} />
          <Route path="events" element={<AdminEventsPage />} />
          <Route path="games" element={<AdminGamesPage />} />
          <Route path="partnerships" element={<AdminPartnershipPage />} />
          <Route path="game-analytics" element={<GameAnalyticsPage />} />
          <Route path="staff-applications" element={<AdminStaffApplicationPage />} />

        </Route>
      </Routes>
      
      {/* Vercel Speed Insights */}
      <SpeedInsights />
    </Router>
  );
}
